/*  英文包  */
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu': 'The cloud',
        'headerlangSelect': 'Please select language',
        'headerLoginOut': 'Logout Now',
        
        /*  侧边栏语言设定 */
        'sideMenuFileName': 'All document',
        'sideMenuPhoto': 'The picture',
        'sideMunsDoc': 'The document',
        'sideMenuVideo': 'Video',
        'sideMenuSeed': 'Seeds',
        'sideMenuMusic': 'Music',
        'sideMenuOrther': 'Other',
        'sideMenuShareName': 'My share',
        'sideMenuCollectName': 'The recycle bin',
        'sideUsedSpace': 'Used',
        'sideDownloadSpace': 'Download',
        'sideMonthlyDownloadNotice': 'Tip: The file download size occupies the download space, and the download will be restricted after it is exceeded.',
        
        /*  用户语言设定 */
        'mainUpload': 'Upload',
        'mainBuildDir': 'New folder',
        'mainDownloadOutline': 'Download Outline',
        'mainSearch': 'Search your files',
        'mainAllFile': 'All',
        'mainFile': 'file',
        'mainSize': 'size',
        'mainDate': 'date',
        'mainFileDel': 'File-Del',
        'mainConfirmDel': 'File will be put into recycle bin after deletion,continue?',
        'sure': 'Ok',
        'cancel': 'Cancel',
        'mainReturn': 'Return',
        'mainPagePrev': 'Prev Page',
        'mainPageNext': 'Next Page',
        'mainLoaded': 'All loaded',
        'mainTotal': 'total',
        'mainUnit': 'lines',
        'dilatation': 'Expansion',
        /*  回收站设定  */
        'mainHeaderTitle': 'Notice：The recycle bin does not take up network disk space.',
        'mainHeaderButton': 'Empty Recycle Bin',
        'collectName': 'Recycle bin',
        'mainRevertIts': 'Reduction',
        'mianDelData': 'Delete time',
        
        'confirmClear': 'Confirm to clear selected files? (Cannot recover after clearing)',
        'confirmClearAll': 'Are you sure you want to empty the recycle bin?',
        
        /*  其他设定 */
        'messageBoxTitle': 'prompt',
        'messageBoxConfirmRevert': 'Confirm to restore the selected file?',
        'loading': 'Loading...',
        'loaded': 'No data',
        
        'messageMoveTo': 'Move to',
        'filterNotice': 'Enter keywords to filter',
        'messageLoaded': 'Downloaded:',
        'messageMovetion': 'File move',
        
        'messageMissKeyWord': 'Please enter the search keyword',
        'messageFolderLayersLimit': 'Creation failed The folder hierarchy depth does not exceed 5 levels',
        'messageSameFolderName': 'Creation failed The same file name exists',
        'messageEmptyFolderName': 'Please enter a folder name',
        'messageMoveSame': 'Cannot move to the same folder',
        'messageActionError': 'Operation failed',
        'messageActionSuccess': 'Successful operation',
        'messageServerIsBusy': 'Server is busy',
        'messageUploadOverLimit': 'Too many files selected (within 5)',
        'messageDiskFreeFull': 'Insufficient user space',
        'messageUploadTypeError': 'Unable to upload this type of file',
        'messageUploadMaxSize': 'The upload file is too large (within 5M)',
        'messageUploadSuccess': 'Uploaded successfully',
        'messageUploadFailed': 'upload failed',
        'messageDownloadFailed': 'download failed',
        'messageMonthFlowLimit': 'The upload/download traffic exceeds the limit in this month, and this operation limit is within 64KB',
        'messageDownloadMax': 'The download file is too large (within 5M)',
        
        
        'systemRequestError': 'Request failed',
        'fileSizeError': 'The file is too large',
        'fileFlowIn64': 'This month\'s download\/upload limit is within 64KB',
        'systemDownloadOverFlow': 'This month\'s download space is full',
        
        
        'fileDownload': 'Download',
        'fileDelete': 'Delete',
        'fileRemove': 'Move',
    },
    ...enLocale
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js